export { Mercaderia } from './componente/mercaderia';
export { Categoria } from './componente/categoria';
export { DetalleVenta } from './componente/detalleVenta';
export { DetalleIngreso } from './componente/detalleIngreso';
export { Grupo } from './componente/grupo';
export { Ingreso } from './componente/ingreso';
export { Venta } from './componente/venta';
export { Rol } from './componente/rol';
export { Usuario } from './componente/usuario';
export { DetalleCaja } from './componente/detalleCaja';
export { Caja } from './componente/caja';
export {Color} from './componente/color'